export const DEFAULT_LOCALE = 'en';
export const REFRESH_TOKEN_TIMEOUT_IN_MS = 1000 * 5;
export const NOTIFICATIONS_POLLING_DELAY_IN_MS = 10000;
export const LRS_HEALTH_CHECK_POLLING_DELAY_IN_MS = 1000 * 5;
export const AUTO_LOGOUT_TIMEOUT = 600000; // 10 minutes
export const DASHBOARD_VIDEO_ID = 'eI3OOpyzoQM';
export const CAPITALISE_INTRODUCTION_VIDEO_ID = 'a01M2nR43CQ';
export const COLLECTIVE_ACTIVITIES_MODAL_KEY = 'collective-funding-searches';
export const MONITOR_ADD_CLIENT_WIZZARD_MODAL_KEY = 'monitor_add_client';
export const MONITOR_CREATE_CLIENT_WIZZARD_MODAL_KEY = 'monitor_create_client';
export const QUESTIONNAIRE_MODAL_KEY = 'marketplace';
export const CAPITAL_REPORT_MODAL_KEY = 'capital_report';
export const INACTIVE_USERS_LIMIT_IN_DAYS = 60;
export const RECOVERY_PROFILE_ID_KEY = 'RECOVERY_PROFILE_ID_KEY';
export const PROPERTY_PROFILE_ID_KEY = 'PROPERTY_PROFILE_ID_KEY';
export const GRANTS_PROFILE_ID_KEY = 'GRANTS_PROFILE_ID_KEY';
export const LOANS_PROFILE_ID_KEY = 'LOANS_PROFILE_ID_KEY';
export const WORKING_CAPITAL_PROFILE_ID_KEY = 'WORKING_CAPITAL_PROFILE_ID_KEY';
export const BUSINESS_WORKING_CAPITAL_PROFILE_ID_KEY = 'BUSINESS_WORKING_CAPITAL_PROFILE_ID_KEY';
export const BUSINESS_ANONYMOUS_WORKING_CAPITAL_PROFILE_ID_KEY =
  'BUSINESS_ANONYMOUS_WORKING_CAPITAL_PROFILE_ID_KEY';
export const ALL_PRODUCTS_PROFILE_ID_KEY = 'ALL_PRODUCTS_PROFILE_ID_KEY';
export const CREDIT_IMPROVEMENT_PROFILE_ID_KEY = 'CREDIT_IMPROVEMENT_PROFILE_ID_KEY';
export const BUSINESS_CREDIT_IMPROVEMENT_PROFILE_ID_KEY =
  'BUSINESS_CREDIT_IMPROVEMENT_PROFILE_ID_KEY';
export const BUSINESS_PROPERTY_PROFILE_ID_KEY =
  'BUSINESS_PROPERTY_PROFILE_ID_KEY';
export const BUSINESS_CREDIT_REVIEW_PROFILE_ID_KEY = 'BUSINESS_CREDIT_REVIEW_PROFILE_ID_KEY';
export const BUSINESS_CREDIT_REVIEW_BY_INTRODUCER_PROFILE_ID_KEY =
  'BUSINESS_CREDIT_REVIEW_BY_INTRODUCER_PROFILE_ID_KEY';
export const RD_TAX_CLAIMS_PROFILE_ID_KEY = 'RD_TAX_CLAIMS_PROFILE_ID_KEY';
export const FUNDING_SEARCH_PROFILE_SECTION = 'FUNDING_SEARCH_PROFILE_SECTION';
export const NO_AUTH_LOCATION_PATHNAME = 'NO_AUTH_LOCATION_PATHNAME';
export const RECOVERY_SERVICE_FORM_LINK = 'https://capitalise.typeform.com/to/XTR7wU';
export const FUNDING_DOCUMENT_ACCEPTED_FILES = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'application/pdf',
  '.csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
];

export const INTEGRATION_UPLOAD_ACCEPTED_FILES = [
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
];

export const INTEGRATION_MAX_FILE_SIZE_KB = 512000;

export const INTEGRATION_UPLOAD_FILE_CONFIG = {
  accept: INTEGRATION_UPLOAD_ACCEPTED_FILES,
  maxSize: INTEGRATION_MAX_FILE_SIZE_KB,
  multiple: false,
};

export const FUNDING_DOCUMENT_MAX_FILE_SIZE_KB = 30720000;

export const MONITOR_FILTERING_OVERLAY_DURATION = 300;

export const SIGNUP_FROM_QUESTIONNAIRE = 'SIGNUP_FROM_QUESTIONNAIRE';
